<template>
  <div class="layout-theme classic">
    <LayoutHeader></LayoutHeader>
    <LayoutSidebar></LayoutSidebar>
    <main class="content-wrapper">
      <perfect-scrollbar class="scrollbar-sidebar">
        <slot></slot>
        <LayoutFooter />
      </perfect-scrollbar>
    </main>
  </div>
</template>
<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import LayoutHeader from "./classic/HeaderLayout.vue";
import LayoutSidebar from "./classic/SidebarLayout.vue";
import LayoutFooter from "./classic/FooterLayout.vue";

export default {
    name: "ClassicLayout",
    components: {
        PerfectScrollbar,

        LayoutHeader,
        LayoutSidebar,
        LayoutFooter,
    },
};
</script>
